import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  ViewEncapsulation
} from "@angular/core";

import type { HomeDecisionDetailComponent } from "./home-decision-detail.component";
import type { DecisionDetail } from "../../../models/home";

@Component({
  selector: "app-home-decision-supporting-sections",
  templateUrl: "./home-decision-supporting-sections.component.html",
  styleUrls: [
    "./home-decision-detail.component.shell-and-summary.scss",
    "./home-decision-detail.component.timeline-and-actions.scss",
    "./home-decision-detail.component.missing-data-and-responsive.scss"
  ],
  encapsulation: ViewEncapsulation.None,
  host: { style: "display: contents" },
  standalone: false
})
export class HomeDecisionSupportingSectionsComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) view!: HomeDecisionDetailComponent;
  @Input({ required: true }) decision!: NonNullable<DecisionDetail["decision"]>;

  @ViewChild("evidenceSection") evidenceSection?: ElementRef<HTMLElement>;
  @ViewChild("missingInformationSection") missingInformationSection?: ElementRef<HTMLElement>;
  @ViewChild("sourceTraceSection") sourceTraceSection?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.view.evidenceSection = this.evidenceSection;
    this.view.missingInformationSection = this.missingInformationSection;
    this.view.sourceTraceSection = this.sourceTraceSection;
  }

  ngOnDestroy(): void {
    if (this.view.evidenceSection === this.evidenceSection) this.view.evidenceSection = undefined;
    if (this.view.missingInformationSection === this.missingInformationSection) {
      this.view.missingInformationSection = undefined;
    }
    if (this.view.sourceTraceSection === this.sourceTraceSection) this.view.sourceTraceSection = undefined;
  }
}
